import * as yup from 'yup';

export const schemaCadastroDispositivo = yup.object().shape({
  descricao: yup.string().max(25, 'Descrição muito longa').required('A descrição é obrigatória.'),
  dispMac: yup.string().max(25, 'Endereço MAC muito longo').required('O MAC é obrigatório.'),
  ativo: yup.bool().required(),
});
